import React, { useState } from "react";
import SwoodleUpdatedLogo from "../../../Assets/Icons/SwoodleUpdatedLogo.svg";
// SearchBar removed for this page as per requirement

const FundraiserHeader = ({ brandLogo, onSearch, showSearchBar = true }) => {
  const [navSearchQuery, setNavSearchQuery] = useState("");

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && onSearch) {
      onSearch(navSearchQuery);
    }
  };
  return (
    <div className={`bg-[#002042] px-[4%] 2xl:px-[3%] py-[2%] sm:py-[1%] flex justify-between items-center`}>
      <div className="flex items-center gap-4">
        {brandLogo ? (
          <img
            src={process.env.REACT_APP_S3_URL + brandLogo}
            className="h-[35px] sm:h-[45px] w-auto rounded-md"
          />
        ) : null}
        <a href="https://swoodle.com.au/" target="_blank" rel="noopener noreferrer">
          <img src={SwoodleUpdatedLogo} className="w-[130px] sm:w-[160px] lg:w-[180px]" alt="Swoodle" />
        </a>
      </div>
      {/* Search removed intentionally */}
    </div>
  );
};

export default FundraiserHeader;
